import { render, staticRenderFns } from "./sign_stocksake1.vue?vue&type=template&id=5020cc01&scoped=true"
import script from "./sign_stocksake1.vue?vue&type=script&lang=js"
export * from "./sign_stocksake1.vue?vue&type=script&lang=js"
import style0 from "./sign_stocksake1.vue?vue&type=style&index=0&id=5020cc01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020cc01",
  null
  
)

export default component.exports